import {
  AdminScheduleVisitResponse,
  adminScheduleVisitResponseSchema,
  StaffScheduling,
} from "~/services";
import type { ServiceResponse } from "./api.types";
import { api } from "./axios";

const toFormData = (visitData: StaffScheduling) => {
  const formData = new FormData();

  Object.entries(visitData).forEach(([key, value]) => {
    if (value === undefined || value === null) return;

    formData.append(key, value instanceof File ? value : String(value));
  });

  return formData;
};

export const registerAndBook = async ({
  visitData,
}: {
  visitData: StaffScheduling;
}): Promise<AdminScheduleVisitResponse> => {
  const hasCardPhoto =
    visitData.insuranceCardFront instanceof File ||
    visitData.insuranceCardBack instanceof File;

  const response = await api.post<ServiceResponse<AdminScheduleVisitResponse>>(
    `/admin/patient-registration-booking`,
    hasCardPhoto ? toFormData(visitData) : visitData,
    hasCardPhoto
      ? { headers: { "Content-Type": "multipart/form-data" } }
      : undefined,
  );

  return adminScheduleVisitResponseSchema.parse(response.data.data);
};
